// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".DatePickerSingle-trigger__l9BrS:focus{outline:none}.DatePickerSingle-trigger__l9BrS:focus-visible{--input-base-background: var(--gray-a2);--input-base-outline-color: var(--gray-12);--input-base-shadow: none}.DatePickerSingle-mobileInput__qEN1E{display:flex;flex:0 0 auto;flex-direction:column;gap:var(--size-3);align-self:stretch;padding:var(--size-3) var(--size-4);border-radius:var(--border-radius-0)}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"trigger": "DatePickerSingle-trigger__l9BrS",
	"mobileInput": "DatePickerSingle-mobileInput__qEN1E"
};
export default ___CSS_LOADER_EXPORT___;
